import React from 'react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_nutrifit-portal/artifacts/s4srivcq_Logo%20Icono%20Solo%20Nutriquimia%20SVG.svg";

export const NutriGymLogo = ({ size = 'md', variant = 'light', showText = true }) => {
  const sizes = {
    sm: { icon: 28, text: 'text-lg' },
    md: { icon: 40, text: 'text-2xl' },
    lg: { icon: 56, text: 'text-4xl' },
    xl: { icon: 72, text: 'text-5xl' }
  };

  const iconSize = sizes[size].icon;
  const textSize = sizes[size].text;
  const textColor = variant === 'light' ? 'text-white' : 'text-[#467322]';

  return (
    <div className="flex items-center gap-3" data-testid="nutriquimia-logo">
      <img 
        src={LOGO_URL} 
        alt="Nutriquimia Logo" 
        style={{ width: iconSize, height: iconSize }}
        className="object-contain"
      />
      {showText && (
        <span className={`font-bold ${textSize} ${textColor}`} style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
          Nutriquimia App
        </span>
      )}
    </div>
  );
};

export default NutriGymLogo;
